import { useCallback, useState } from 'react';
import { v4 as uuid } from 'uuid';
export default function useLoadTracker() {
    const [loaders, setLoaders] = useState([]);
    const addLoader = useCallback((id, message) => {
        if (!id) {
            id = uuid();
        }
        setLoaders((existing) => {
            return [...existing, { id, message }];
        });
        return id;
    }, []);
    const removeLoader = useCallback((id) => {
        setLoaders((loaders) => {
            return loaders.filter((loader) => loader.id !== id);
        });
    }, []);
    const getLoaderMessage = useCallback((id) => {
        loaders.find((loader) => loader.id === id)?.message;
    }, [loaders]);
    const loadTracker = {
        addLoader,
        removeLoader,
        getLoaderMessage,
        count: loaders.length,
        isLoading: loaders.length > 0,
    };
    return loadTracker;
}
//# sourceMappingURL=UseLoadTracker.js.map